import React from 'react';
import { Box } from '@mui/material';
import { LANDING_FONT, LC } from './landingTokens';

// Single landing action style: accent fill, dark ink (white fails AA on accent
// at body size — Brand brief §3). Renders as a link or button.
export default function LandingButton({ children, href, onClick, sx, ...rest }) {
  return (
    <Box
      component={href ? 'a' : 'button'}
      href={href}
      onClick={onClick}
      sx={{
        fontFamily: LANDING_FONT,
        fontWeight: 800,
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
        cursor: 'pointer',
        border: 'none',
        whiteSpace: 'nowrap',
        background: LC.accent,
        color: LC.accentInk,
        transition: 'background 150ms ease',
        '&:hover': { background: LC.accentHover },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
